export default "__VITE_ASSET__CcyfTP6z__"